<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }

  .content {
    padding: 29px 40px;
  }
  .form-wrapper {
    width: 280px;
    margin: 0 auto;
    .abs-center;
  }
</style>

<template lang="pug">
  section.content
    form.search-bar
      h2 정보수정
    .form-wrapper
      login-form(
        :hideRegister="true",
        :currentTab="currentTab",
        :visible="visible",
        :searchedUsername="searchedUsername",
        :sentEmail="sentEmail",
        @login="login",
      )
</template>

<script>
import { mapState } from 'vuex';
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'UserVerify',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState({
      me: state => state.me,
    }),
  },
  data() {
    return {
      currentTab: 'username', // 'username', 'password'
      visible: false,
      searchedUsername: null,
      sentEmail: null,
    };
  },
  methods: {
    async login({ username, password }) {
      // TODO: login API. request body에 유저 데이터 store에 저장. token은 loalstorage 저장
      try {
        if (this.me.id !== username) {
          this.$alert('아이디 또는 비밀번호가 일치하지 않습니다.', {
            confirmButtonText: '확인',
          });
        } else {
          const login = await this.$http.post('/api/mkc/v1/login', { id: username, passwd: password });
          const { token } = login.data;
          this.$localStorage.set('token', token);
          this.$http.defaults.headers.common['mk-sess'] = token;
          await this.$store.dispatch('fetchMe');
          this.$router.replace('/user/form');
        }
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
  },
};
</script>
